/* ---------- MCC-002's unit door bonded to -XD2's PE (#3957, as MCC-001's units', #3956) ----------
 * -QA20's door has its earth stud (-XE2), given, on a strap of its own from -XD2's PE (board.ts). A save made before holds a unit
 * wired without it, which the Wiring step would now call missing. How such a save is read: the save migration in packages/progress
 * uses this (format 41). Self-contained on purpose, as MCC-001's doorbond.ts: the migration imports this file alone, not MCC-002's pack. */

/** The strap, as the wiring list has it (board.ts, DOOR_STRAP). */
export const MCC002_DOOR_STRAP = { from: "XD2:PE", to: "XE2:PE" } as const;

/** A build record ({ placements, wires }) with the door's strap where -XD2's PE is already wired (the cable's PE core landed): the unit
 *  changed under the learner's work, so its strap comes with it, as MCC-001's (format 40). The Wiring step gives it the list's colour
 *  and mark when it loads. Anything else (-XD2's PE not wired yet, the strap already there) keeps its wires. */
function build(b: any): any {
  const s = MCC002_DOOR_STRAP, wires: any[] = Array.isArray(b?.wires) ? b.wires : [];
  const onPe = wires.some(w => w?.from === s.from || w?.to === s.from);
  const there = wires.some(w => [w?.from, w?.to].sort().join("|") === [s.from, s.to].sort().join("|"));
  return onPe && !there ? { ...b, wires: [...wires, { from: s.from, to: s.to }] } : b;
}
const one = (ui: any): any => ui && typeof ui === "object" && ui.build ? { ...ui, build: build(ui.build) } : ui;
/** A saved MCC-002 project ({ model, ui }) with its door's strap: its own work and each earlier attempt it keeps. */
export function doorBondMcc002Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = s?.ui ? { ...s, ui: one(s.ui) } : s;
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => a?.ui ? { ...a, ui: one(a.ui) } : a) } : out;
}
